import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.marquee__splide' ).length ) {
        const sliders = [];

        $( '.marquee__splide' ).each( function( index, element ) {
          const marqueText = $( element ).find( '.marquee__slide-text .marquee-text' );
          let marqueTextWidth = 0;
          marqueText.each( function( index, el ) {
            marqueTextWidth = marqueTextWidth + $( el ).outerWidth();
          } );
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            gap: '2rem',
            arrows: false,
            fixedWidth: `${marqueTextWidth}px`,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: true,
              pauseOnHover: true,
            },
          } );

          if ( window.hasMotion ) {
            $( '.marquee-toggle-state' ).removeClass( 'is-paused' );
          }

          slider.mount( {AutoScroll} );
          sliders.push( slider );
        } );

        $( document ).on( 'click', '.marquee-toggle-state', function() {
          $( this ).toggleClass( 'is-paused' );
          const isPaused = $( this ).hasClass( 'is-paused' );
          sliders.forEach( function( slider ) {
            if ( isPaused ) {
              slider.Components.AutoScroll.pause();
            } else {
              slider.Components.AutoScroll.play();
            }
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'marquee', COMPONENT );
} )( app );
